export function dateTime() {
  const clock = document.querySelectorAll('.js-clock');
  if (clock) {
    for (let i = 0; i < clock.length; i++) {
      const el = clock[i];
      
      const getDateTime = () => {
        // 今日の日付データをcurrentDateに格納
        const currentDate = new Date();

        // 年・月・日・曜日を取得
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const date = currentDate.getDate();
        const day = currentDate.getDay();
        const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

        // 時間を取得
        const hour = formatTime(currentDate.getHours());
        const minute = formatTime(currentDate.getMinutes());
        const second = formatTime(currentDate.getSeconds());

        // 0~9の数値に0を足して2桁にする関数(例: 0:0:0 -> 00:00:00)
        function formatTime(val) {
          return ("0" + val).slice(-2);
        }

        // 取得した日付・時間をアウトプット
        el.innerText = `${year}/${month}/${date}(${weekday[day]}) ${hour}:${minute}:${second}`;
      }
      setInterval(getDateTime,1000);
    }
  }
}